import { formUrl } from './links/form-url'

export const getWorkflowEditorUrl = (id: number | string) => formUrl(`/workflow/${id}/edit`) ?? ''
